import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import './styles.scss'

interface ProgressProps {}

interface ProgressState {
  show: boolean
}

const defaultState = { show: false }
class Progress extends Component<ProgressProps, ProgressState> {
  constructor(props: any, context: any) {
    super(props, context)
    this.state = {
      ...defaultState,
    }
  }

  start() {
    // 开始显示
    this.setState({
      show: true,
    })
  }

  done() {
    // 结束隐藏
    this.setState({
      show: false,
    })
  }
  render() {
    return (
      <div
        className='progress'
        style={{
          display: this.state.show ? 'block' : 'none',
        }}
      >
        <div className="bar">
          <div className="peg"></div>
        </div>
        <div className="spinner">
          <div className="spinner-icon"></div>
        </div>
      </div>
    )
  }
}

// 创建元素追加到body
const div = document.createElement('div')
const props = {}
document.body.appendChild(div)

const Box = ReactDOM.render(React.createElement(Progress, props), div)
export default Box
